export const Version = '1.0.0';

let h = location.origin;
export const host = h;
// console.log(h,123)
export const imgHost = 'https://cdn2024.shiwuzone.com/routuan'
export const defaultHeader = 'http://cdn2024.shiwuzone.com/routuan/image/pcDefaultHeader.png'
export const maxspecifications = 5//最大规格层级
export const MallKey = 'shiwuzone'//二级域名
//页面
export const pagetypelist:any = [
  {value:1,label:'系统页面',ref:'system'},
  {value:2,label:'商品分类',ref:'classification'},
  {value:3,label:'商品',ref:'commodity'},
  {value:4,label:'自定义页面',ref:'customize'},
  {value:5,label:'营销活动',ref:'marketingActive'},
  {value:6,label:'小程序链接',ref:'appletLink',showPage:['/malldecoration/decoration','/malldecoration/operatedisposition','/material/popupadvertising', '/product/product-detail','/marketing/turntableDetails']},
  {value:12,label:'直播',ref:'live',showPage:['/material/popupadvertising','/malldecoration/decoration','/malldecoration/operatedisposition', '/malldecoration/customizepage','/marketing/turntableDetails']},
  {value:13,label:'优惠券',ref:'coupon',showPage:['/malldecoration/decoration']},
]
//分销员等级
export const menberlevelList = [
  {
    label: '全部',
    value: null
  }, {
    label: 'VIP',
    value: 3
  }, {
    label: 'VIC',
    value: 2
  }, {
    label: 'SVIC',
    value: 1
  }, 
  // {
  // 	label: '客户',
  // 	value: 0
  // }
]

export const RoleData = [{
  text: '未知',
  en: 'normal',
  value: 0
}, {
  text: '超级管理员',
  en: 'admin',
  value: 1
}, {
  text: '供应商',
  en: 'provider',
  value: 2
}]

export const afterSalesTypes = [{
  label: '全部售后类型',
  value: 0
}, {
  label: '商品补发',
  value: 1
}, {
  label: '退货退款',
  value: 2
}, {
  label: '商品换货',
  value: 3
}]

export const afterSalesResults = [{
  label: '全部售后原因',
  value: 0
}, {
  label: '质量问题',
  value: 1
}, {
  label: '大小尺寸与描述不符',
  value: 2
}, {
  label: '卖家发错',
  value: 3
}, {
  label: '商品损坏/污渍',
  value: 4
}, {
  label: '其他',
  value: 5
}]

export const grade = [{
  label: '普通用户',
  value: 0
}, {
  label: 'VIP',
  value: 1
}, {
  label: 'VIC',
  value: 2
}, {
  label: 'SVIC',
  value: 3
}, {
  label: '公司',
  value: 4
}]

export const units = [{
  label: '个',
  value: '个'
}, {
  label: '件',
  value: '件'
}, {
  label: '瓶',
  value: '瓶'
}, {
  label: '双',
  value: '双'
}, {
  label: '套',
  value: '套'
}, {
  label: '只',
  value: '只'
}, {
  label: '付',
  value: '付'
}, {
  label: '把',
  value: '把'
}, {
  label: '包',
  value: '包'
}, {
  label: '盒',
  value: '盒'
}, {
  label: '升',
  value: '升'
}, {
  label: '方',
  value: '方'
}, {
  label: '块',
  value: '块'
}, {
  label: '箱',
  value: '箱'
}, {
  label: '条',
  value: '条'
}, {
  label: '台',
  value: '台'
}]

export const orderStates = [{
  label: '全部',
  value: null
}, {
  label: '待支付',
  value: 5
},{
  label: '审核中',
  value: 0
}, {
  label: '待发货',
  value: 10
}, {
  label: '已发货',
  value: 20
}, {
  label: '已完成',
  value: 30
}, {
  label: '已取消',
  value: 40
}, 
// {
//   label: '售后中',
//   value: 5
// }
]

const today = new Date(new Date().toLocaleDateString()).getTime() / 1000;
const ONE_DAY = 86400
export const timeScope: any = [{
  label: '昨日',
  value: 1
}, {
  label: '今日',
  value: 2
}, {
  label: '近7天',
  value: 3
}, {
  label: '近30日',
  value: 4
}]

export const afterStatus: any = [{
  label: '全部状态',
  value: 0
}, {
  label: '待供应商确认',
  value: 1
}, {
  label: '待退货',
  value: 2
}, {
  label: '待补发',
  value: 3
}, {
  label: '待供应商确认售后',
  value: 4
}, {
  label: '待确认',
  value: 5
}, {
  label: '驳回',
  value: 6
}, {
  label: '取消',
  value: 7
}, {
  label: '完成',
  value: 8
}]